import styled from "styled-components";

export const StyledDiv = styled.div`
  flex-grow: 1;

  > div {
    display: flex;
    align-items: center;
    gap: 24px;
    padding-bottom: 24px;
  }
`;

export const StyledForm = styled.form`
  display: none;

  &.visible {
    display: block;
  }
`;

export const DropdownsDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;

  > div:first-child {
    width: 500px;
  }

  > div:not(:first-child) {
    margin-left: 60px;
    width: 250px;
  }
`;
